import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { Fieldset } from "primereact/fieldset";
import { BreadCrumb } from "primereact/breadcrumb";
import { InputSwitch } from "primereact/inputswitch";

import { api } from "../../../utils/api";
import Panel from "../../../components/panel/panel";

import "react-toastify/dist/ReactToastify.css"; // Importe os estilos padrão
import { toast } from "react-toastify";
import { Skeleton } from "primereact/skeleton";
import usePermission from "../../../hooks/usePermission";

const GeneralAddressConfiguration = () => {
  usePermission("144"); // Visualizar/Editar Configurações do Cadsatro Geral
  const items = [
    {
      template: () => (
        <Link to={`/settings/generalAddressConfiguration`} className="p-breadcrumb-link">
          Obrigatoriedades Cadastro Geral
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const panel1 = (
    <div className="text-start d-flex justify-content-start text-success py-3">
      <span className="pi pi-user mx-2"></span>
      <h4>Informações Básicas</h4>
    </div>
  );

  const panel2 = (
    <div className="text-start d-flex justify-content-start text-success py-3">
      <span className="pi pi-user mx-2"></span>
      <h4>Informações Pessoa Física</h4>
    </div>
  );

  const panel3 = (
    <div className="text-start d-flex justify-content-start text-success py-3">
      <span className="pi pi-user mx-2"></span>
      <h4>Informações Pessoa Jurídica</h4>
    </div>
  );

  const panel4 = (
    <div className="text-start d-flex justify-content-start text-success py-3">
      <span className="pi pi-user mx-2"></span>
      <h4>Endereço</h4>
    </div>
  );

  const panel5 = (
    <div className="text-start d-flex justify-content-start text-success py-3">
      <span className="pi pi-user mx-2"></span>
      <h4>Documentos</h4>
    </div>
  );

  const navigate = useNavigate();

  const [loading, setloading] = useState(false);
  const [checkedFields, setCheckedFields] = useState([]);

  const toggleChecked = (field) => {
    setCheckedFields((prevCheckedFields) => {
      const isFieldChecked = prevCheckedFields.some(
        (item) => item.name === field.name && item.type === field.type
      );

      if (isFieldChecked) {
        return prevCheckedFields.filter(
          (item) => !(item.name === field.name && item.type === field.type)
        );
      } else {
        return [...prevCheckedFields, field];
      }
    });
  };

  const onSubmit = async () => {
    try {
      setloading(true);
      const response = await api.post("form-client-config", checkedFields);

      toast.success(response.data.success);
    } catch (e) {
      if (!e.response.data.error) navigate("/login");

      setloading(false);
      toast.error(e.response.data.error);
    } finally {
      setloading(false);
    }
  };

  const fetchData = async () => {
    setloading(true);
    try {
      const response = await api.get("form-client-config?with_type=1", {});

      setCheckedFields(response.data);
      setloading(false);
    } catch (e) {
      if (!e.response.data.error) navigate("/login");

      toast.error(e.response.data.error);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="col-xl-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      {loading && (
        <>
          <div className="col-md-12">
            <div className="card flex rounded-4 px-4">
              <div className="flex mb-5">
                <div className="py-3">
                  <Skeleton width="75%" height="2rem"></Skeleton>
                </div>
              </div>
              <div className="pb-2">
                <Skeleton width="100%" height="50px"></Skeleton>
              </div>
            </div>
          </div>
        </>
      )}
      {!loading && (
        <>
          <Panel mainCss="mb-4">
            <Fieldset legend={panel1}>
              <div className="d-flex row">
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Email</p>
                  <InputSwitch
                    name="email"
                    id="email"
                    checked={checkedFields.some(
                      (item) => item.name === "email" && item.type === 1
                    )}
                    onChange={() => toggleChecked({ name: "email", type: 1 })}
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Contato</p>
                  <InputSwitch
                    name="contacts"
                    id="contacts"
                    checked={checkedFields.some(
                      (item) => item.name === "contacts" && item.type === 1
                    )}
                    onChange={() =>
                      toggleChecked({ name: "contacts", type: 1 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Observação</p>
                  <InputSwitch
                    name="obs"
                    id="obs"
                    checked={checkedFields.some(
                      (item) => item.name === "obs" && item.type === 1
                    )}
                    onChange={() => toggleChecked({ name: "obs", type: 1 })}
                  />
                </div>
                {/* <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Creci</p>
                  <InputSwitch
                    name="creci"
                    id="creci"
                    checked={checkedFields.some(
                      (item) => item.name === "creci" && item.type === 1
                    )}
                    onChange={() => toggleChecked({ name: "creci", type: 1 })}
                  />
                </div> */}
              </div>
            </Fieldset>
          </Panel>
          <Panel mainCss="mb-4">
            <Fieldset legend={panel2}>
              <div className="d-flex row">
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">RG</p>
                  <InputSwitch
                    name="rg"
                    checked={checkedFields.some(
                      (item) => item.name === "rg" && item.type === 2
                    )}
                    onChange={() => toggleChecked({ name: "rg", type: 2 })}
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Órgão Expedidor</p>
                  <InputSwitch
                    name="issuing_authority"
                    checked={checkedFields.some(
                      (item) =>
                        item.name === "issuing_authority" && item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "issuing_authority", type: 2 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Data de Emissão</p>
                  <InputSwitch
                    name="date_issuing_authority"
                    checked={checkedFields.some(
                      (item) =>
                        item.name === "date_issuing_authority" &&
                        item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "date_issuing_authority", type: 2 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Nome Mãe</p>
                  <InputSwitch
                    name="name_mother"
                    checked={checkedFields.some(
                      (item) => item.name === "name_mother" && item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "name_mother", type: 2 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Nome pai</p>
                  <InputSwitch
                    name="name_father"
                    checked={checkedFields.some(
                      (item) => item.name === "name_father" && item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "name_father", type: 2 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Renda Familiar</p>
                  <InputSwitch
                    name="family_income"
                    checked={checkedFields.some(
                      (item) => item.name === "family_income" && item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "family_income", type: 2 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Data de Nascimento</p>
                  <InputSwitch
                    name="date_of_birth"
                    checked={checkedFields.some(
                      (item) => item.name === "date_of_birth" && item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "date_of_birth", type: 2 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Nacionalidade</p>
                  <InputSwitch
                    name="nationality"
                    checked={checkedFields.some(
                      (item) => item.name === "nationality" && item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "nationality", type: 2 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Estado Civil</p>
                  <InputSwitch
                    name="marital_status"
                    checked={checkedFields.some(
                      (item) =>
                        item.name === "marital_status" && item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "marital_status", type: 2 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Profissão</p>
                  <InputSwitch
                    name="profession"
                    checked={checkedFields.some(
                      (item) => item.name === "profession" && item.type === 2
                    )}
                    onChange={() =>
                      toggleChecked({ name: "profession", type: 2 })
                    }
                  />
                </div>
              </div>
            </Fieldset>
          </Panel>
          <Panel mainCss="mb-4">
            <Fieldset legend={panel3}>
              <div className="d-flex row">
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Inscrição Estadual</p>
                  <InputSwitch
                    name="state_registration"
                    checked={checkedFields.some(
                      (item) =>
                        item.name === "state_registration" && item.type === 3
                    )}
                    onChange={() =>
                      toggleChecked({ name: "state_registration", type: 3 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Inscrição Municipal</p>
                  <InputSwitch
                    name="municipal_registration"
                    checked={checkedFields.some(
                      (item) =>
                        item.name === "municipal_registration" &&
                        item.type === 3
                    )}
                    onChange={() =>
                      toggleChecked({ name: "municipal_registration", type: 3 })
                    }
                  />
                </div>
              </div>
            </Fieldset>
          </Panel>
          <Panel mainCss="mb-4">
            <Fieldset legend={panel4}>
              <div className="d-flex row">
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Cep</p>
                  <InputSwitch
                    name="cep"
                    checked={checkedFields.some(
                      (item) => item.name === "cep" && item.type === 4
                    )}
                    onChange={() => toggleChecked({ name: "cep", type: 4 })}
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Endereço</p>
                  <InputSwitch
                    name="address"
                    checked={checkedFields.some(
                      (item) => item.name === "address" && item.type === 4
                    )}
                    onChange={() => toggleChecked({ name: "address", type: 4 })}
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Numero</p>
                  <InputSwitch
                    name="num"
                    checked={checkedFields.some(
                      (item) => item.name === "num" && item.type === 4
                    )}
                    onChange={() => toggleChecked({ name: "num", type: 4 })}
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Bairro</p>
                  <InputSwitch
                    name="neighborhood"
                    checked={checkedFields.some(
                      (item) => item.name === "neighborhood" && item.type === 4
                    )}
                    onChange={() =>
                      toggleChecked({ name: "neighborhood", type: 4 })
                    }
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Cidade</p>
                  <InputSwitch
                    name="city"
                    checked={checkedFields.some(
                      (item) => item.name === "city" && item.type === 4
                    )}
                    onChange={() => toggleChecked({ name: "city", type: 4 })}
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Estado</p>
                  <InputSwitch
                    name="state"
                    checked={checkedFields.some(
                      (item) => item.name === "state" && item.type === 4
                    )}
                    onChange={() => toggleChecked({ name: "state", type: 4 })}
                  />
                </div>
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Complemento</p>
                  <InputSwitch
                    name="complement"
                    checked={checkedFields.some(
                      (item) => item.name === "complement" && item.type === 4
                    )}
                    onChange={() =>
                      toggleChecked({ name: "complement", type: 4 })
                    }
                  />
                </div>
              </div>
            </Fieldset>
          </Panel>
          <Panel mainCss="mb-4">
            <Fieldset legend={panel5}>
              <div className="d-flex row">
                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Comp. de Residência</p>
                  <InputSwitch
                    name="proof_residence"
                    checked={checkedFields.some(
                      (item) =>
                        item.name === "proof_residence" && item.type === 5
                    )}
                    onChange={() =>
                      toggleChecked({ name: "proof_residence", type: 5 })
                    }
                  />
                </div>

                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">Contrato Social</p>
                  <InputSwitch
                    name="social_contract"
                    checked={checkedFields.some(
                      (item) =>
                        item.name === "social_contract" && item.type === 5
                    )}
                    onChange={() =>
                      toggleChecked({ name: "social_contract", type: 5 })
                    }
                  />
                </div>

                <div className={`${window.innerWidth <= 992 ? "col-6" : "col-3"} py-2`}>
                  <p className="m-auto pb-2">CPF</p>
                  <InputSwitch
                    name="cpf"
                    checked={checkedFields.some(
                      (item) => item.name === "cpf" && item.type === 5
                    )}
                    onChange={() => toggleChecked({ name: "cpf", type: 5 })}
                  />
                </div>
              </div>
              <div className="row">
                <div className="pt-5 text-center">
                  <Button
                    rounded
                    label="Salvar"
                    icon="fa fa-plus"
                    className="p-inputtext-sm m-auto"
                    loading={loading}
                    onClick={() => onSubmit()}
                  />
                </div>
              </div>
            </Fieldset>
          </Panel>
        </>
      )}
    </>
  );
};

export default GeneralAddressConfiguration;
